import { findLast } from 'lodash';

import {
  DOCUMENTS_SIDES,
  TENANT_DOCS_DESCRIPTIONS,
} from '../../../../shared/constants';
import { IUserDocument } from '../../../../shared/ts/document';
import { IGuarantor } from '../../../../shared/ts/guarantor';
import { IGuest } from '../../../../shared/ts/user';

const RequiredFieldForItalianStudents: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:universityCertification',
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.UNIVERSITY_CERTIFICATION,
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
];

const RequiredFieldForForeignStudents: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:residencePermit',
    sideLabel: 'common:front',
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.RESIDENCE_PERMIT,
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'form:residencePermit',
    sideLabel: 'common:rear',
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.RESIDENCE_PERMIT,
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  {
    label: 'form:universityCertification',
    type: 'other',
    description: TENANT_DOCS_DESCRIPTIONS.UNIVERSITY_CERTIFICATION,
  },
];

const RequiredFieldForSelfEmployed: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:lastIncomeTaxReturn',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_INCOME_TAX_RETURN,
  },
  {
    label: 'form:secondLastIncomeTaxReturn',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_INCOME_TAX_RETURN,
  },
  {
    label: 'form:latestAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LATEST_ACCOUNT_STATEMENT,
  },
  {
    label: 'form:penultimateAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PENULTIMATE_ACCOUNT_STATEMENT,
  },
  {
    label: 'form:prepenultimateAccountStatement',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.PREPENULTIMATE_ACCOUNT_STATEMENT,
  },
];

const RequiredFieldForEmploye: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:workContract',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.WORK_CONTRACT,
  },
  {
    label: 'form:lastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_PAYCHECK,
  },
  {
    label: 'form:secondLastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PAYCHECK,
  },
  {
    label: 'form:thirdLastPaycheck',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.THIRD_LAST_PAYCHECK,
  },
];

const RequiredFieldForUnEmploye: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
];

const RequiredFieldForRetired: {
  label: string;
  sideLabel?: string;
  type: string;
  description?: string;
  documentSide?: string;
}[] = [
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:front',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.FRONT,
  },
  {
    label: 'common:idCardOrPassport',
    sideLabel: 'common:rear',
    type: 'identity_document',
    documentSide: DOCUMENTS_SIDES.REAR,
  },
  { label: 'form:fiscalCode', type: 'tax_number' },
  {
    label: 'form:lastPensionSlip',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.LAST_PENSION_SLIPS,
  },
  {
    label: 'form:penultimatePensionSlip',
    type: 'proof_of_income',
    description: TENANT_DOCS_DESCRIPTIONS.SECOND_LAST_PENSION_SLIPS,
  },
];

const guestOccupation: Record<
  string,
  {
    label: string;
    sideLabel?: string;
    type: string;
    description?: string;
    documentSide?: string;
  }[]
> = {
  italianStudent: RequiredFieldForItalianStudents,
  foreignStudent: RequiredFieldForForeignStudents,
  selfEmployed: RequiredFieldForSelfEmployed,
  employee: RequiredFieldForEmploye,
  unemployed: RequiredFieldForUnEmploye,
  retired: RequiredFieldForRetired,
};

export const filterRequiredFieldForDocumentTenant = ({
  index,
  occupation,
  guestDocuments,
}: {
  index: number;
  occupation: string;
  guestDocuments?: IUserDocument[];
}) => {
  const requiredFields = guestOccupation[occupation] || [];

  const missingFields = requiredFields
    .filter(field => {
      const document = findLast(guestDocuments, {
        ...(field.description && { description: field.description }),
        type: field.type,
      });

      if (!document) {
        return true;
      }

      if (field.documentSide) {
        const sideField =
          field.documentSide === DOCUMENTS_SIDES.FRONT
            ? document.document_front || document.front
            : document.document_rear || document.rear;

        return !sideField;
      }

      return false;
    })
    .map(field => ({ label: field.label, sideLabel: field.sideLabel }));

  return {
    label:
      index === 0 ? 'common:tenantDocuments' : 'common:otherTenantDocuments',
    fields: missingFields,
  };
};

export const checkForDuplicateEmails = (
  email: string,
  index: number,
  type: 'tenant' | 'guarantor',
  tenants: IGuest[],
  guarantors: IGuarantor[],
): boolean => {
  const emails =
    type === 'tenant'
      ? tenants.map(t => t.user_email)
      : guarantors.map(g => g.email);
  const duplicateEmailIndex = emails.indexOf(email);

  // Return true if there's a duplicate email (other than the current index)
  return duplicateEmailIndex !== -1 && duplicateEmailIndex !== index;
};
